import Swal from "sweetalert2/dist/sweetalert2.js";
import ArefApi from "./api";
import store from "../store";

class websocketHandler {
  constructor(socket) {
    if (!socket) {
      return;
    }
    this.socket = socket;
    if (store.state.token) {
      const checkinData = {
        Type: "CHECKIN",
        Token: store.state.token,
      };
      //console.log("SEND CHECKIN:",checkinData);
      this.socket.sendObj(checkinData);
    }
  }

  close = () => {
    this.socket.close();
  };
  onMessageReceived = (message) => {
    console.log("onMessageReceived:",message);
    const arefApi = new ArefApi();
    if (message.Type == "ERROR_TOKEN_INVALID") {
      let msg_alert = `لطفا مجددا به سایت وارد شوید.`;
      if (message.Error == "socket_login_error") {
        msg_alert = `شخص دیگری با نام کاربری شما وارد سیستم شد - به طور همزمان اتصال همزمان دو کاربر به پرتال امکان پذیر نمی باشد`;
      }
      Swal.fire({
        title: "!خطا",
        text: msg_alert,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
      arefApi.setLogout();
    }
    if (message.Type == "ERROR_TOKEN") {
      Swal.fire({
        title: "!خطا",
        text: `لطفا مجددا به سایت وارد شوید`,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
      arefApi.setLogout();
    }
  };

  onReconnectError() {
    // const arefApi = new ArefApi();
    // Swal.fire({
    //   title: "!خطا",
    //   text: `ارتباط سوکت با سرور برقرار نشد`,
    //   icon: "error",
    //   confirmButtonText: "متوجه شدم",
    // });
    // arefApi.setLogout();
  }
}

export default websocketHandler;
